import React, { useEffect, useState } from "react";
import { Divider, message } from "antd";
import StepItemWidget from "./StepItemWidget";
import { getInitData } from "utils/GlobalFunctions";

const StepFee = (props) => {
  const { userData, setUserData, errorField, setErrorField, srcGroupList } =
    props;
  const [itemList, setItemList] = useState([]);
  useEffect(() => {
    const saved_user_info = localStorage.getItem("basketball_player_info");
    if (saved_user_info != null) {
      let savedUserInfo = getInitData();
      setUserData({
        ...userData,
        ...savedUserInfo,
      });
    }
  }, []);
  useEffect(() => {
    let tmpItemList = [];
    if (userData.feeList.length > 0) {
      tmpItemList = [...userData.feeList];
    } else {
      tmpItemList = [...srcGroupList];
    }
    setItemList(tmpItemList);
  }, [userData]);

  const onCheck = (key, id, fee, title) => {
    let tmpList = [...userData.playerInfo];
    let tmpFeeList = [...itemList];

    // Find the registration group being selected
    let groupIndex = tmpFeeList.findIndex((x) => x.id == id);
    let selectedGroup = tmpFeeList[groupIndex];

    for (let i = 0; i < tmpList.length; i++) {
      let itemInfo = tmpList[i];
      if (i == key) {
        // Check if player is changing selection (not just re-clicking same option)
        let previousSelection = itemInfo.sel_trip;

        if (previousSelection != id) {
          // Check if new selection is full
          if (parseInt(selectedGroup.current_registrations) >= parseInt(selectedGroup.max_registrations)) {
            message.error("This registration is full. No more spots available.");
            return;
          }

          // Update the registration counts
          if (previousSelection != "" && previousSelection != null) {
            // Decrement old selection
            let oldGroupIndex = tmpFeeList.findIndex((x) => x.id == previousSelection);
            if (oldGroupIndex !== -1) {
              tmpFeeList[oldGroupIndex].current_registrations = parseInt(tmpFeeList[oldGroupIndex].current_registrations) - 1;
            }
          }

          // Increment new selection
          selectedGroup.current_registrations = parseInt(selectedGroup.current_registrations) + 1;
          tmpFeeList[groupIndex] = selectedGroup;
        }

        itemInfo.sel_trip = id;
        itemInfo.fee = fee;
        itemInfo.fee_label = title;
      }
      tmpList[i] = itemInfo;
    }

    setItemList(tmpFeeList);
    setUserData({
      ...userData,
      playerInfo: [...tmpList],
      feeList: [...tmpFeeList],
    });
  };
  const onRemove = (id) => {
    let tmpList = [...itemList];
    let itemInfo = tmpList[id];
    itemInfo.checked = false;
    tmpList[id] = itemInfo;
    setItemList(tmpList);
    setUserData({ ...userData, feeList: [...tmpList] });
  };

  return (
    <div className="profile-info-widget" style={{ border: "none" }}>
      <div>
        {userData.playerInfo.map((player, i) => {
          return (
            <div key={i}>
              <span className="title">
                {player.first_name + ` ` + player.last_name}'s Participant Fees
              </span>
              <Divider></Divider>
              {itemList.map((x, index) => {
                return (
                  <StepItemWidget
                    itemInfo={x}
                    onCheck={onCheck}
                    onRemove={onRemove}
                    playerIndex={i}
                    playerInfo={player}
                    key={index}
                  />
                );
              })}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default StepFee;
